// src/services/api.js
import axios from "axios";
import baseURL from "../config";

const organization_id = localStorage.getItem("organization_id");
const session_id = localStorage.getItem("session_id");

const api = axios.create({
  baseURL: baseURL + '/api/v1',
  headers: {
    "Content-Type": "application/json",
    "organization-id": organization_id,
    "session-id": session_id,
  },
});

// Request interceptor for Authorization token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers["Authorization"] = "Bearer " + token;
  
  // ✅ If sending FormData, remove Content-Type so Axios sets it with boundary
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  
  return config;
});

// Response interceptor for global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // handle global errors here
    return Promise.reject(error);
  }
);

export default api;
